/**
 * Supported Languages — single source of truth for the frontend.
 *
 * Any component or config that needs the list of supported languages
 * MUST import from this module. Do not hardcode language lists anywhere
 * else (`i18n/index.js`, LanguageSwitcher, profile language picker, etc.).
 *
 * Backend counterpart: `vitahubco/backend/app/utils/language.py`.
 */
export const SUPPORTED_LANGUAGES = ['en', 'de', 'pt-BR']

export const LANGUAGE_LABELS = {
  en: 'English',
  de: 'Deutsch',
  'pt-BR': 'Português (Brasil)',
}

/**
 * VH-251: the language code to send to the API for translated content.
 *
 * Content is cached per language code, so the code must be exactly one of
 * SUPPORTED_LANGUAGES. Stripping the region ("pt-BR" -> "pt") sent Brazilian
 * users a code the supplement endpoints reject with 400 and cached everything
 * else under a second, European-Portuguese key.
 */
export const contentLanguage = (language) => {
  const raw = language || 'en'
  if (raw.startsWith('pt')) return 'pt-BR'
  if (raw.startsWith('de')) return 'de'
  return 'en'
}
